"use strict";

import { lcvCampaignConstants } from "../_constants/lcvCampaign.constants";

export const lcvCampaignsGetRequest = (payload) => {
     return {
          type: lcvCampaignConstants.LCV_CAMPAIGNS_GET_REQUEST,
          payload,
     };
};

export const lcvCampaignsGetComplete = (payload) => {
     return {
          type: lcvCampaignConstants.LCV_CAMPAIGNS_GET_COMPLETE,
          payload,
     };
};

export const lcvCampaignSelect = (campaignId) => {
     return {
          type: lcvCampaignConstants.LCV_CAMPAIGN_SELECT,
          payload: campaignId,
     };
};
